import { useAuth0 } from "@auth0/auth0-react"
import { Button, Skeleton, Text, HStack, Box } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"
import { t } from "@/lib/i18n"

export const Auth = () => {
  const { isLoading, isAuthenticated, user, logout, loginWithRedirect, error } = useAuth0()
  const navigate = useNavigate()

  const handleUsernameClick = () => {
    navigate("/me")
  }

  if (isLoading) {
    return (
      <HStack>
        <Skeleton height="20px" width="120px" />
        <Skeleton height="32px" width="80px" borderRadius="md" />
      </HStack>
    )
  }

  if (isAuthenticated) {
    return <HStack>
      <Box onClick={handleUsernameClick} cursor="pointer">
        {user?.name}
      </Box>
      <Button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
        {t('ui.logout')}
      </Button>
      <Text />
    </HStack>
  }

  return <HStack>
    {error && <Text>{error.message}</Text>}
    <Button onClick={() => loginWithRedirect()}>
      {t('ui.login')}
    </Button>
  </HStack >
}

